// extracted by mini-css-extract-plugin
export default {"PremierCountrySelector":"CountrySelector_PremierCountrySelector"};